import { Grid, TextField, alpha, useTheme } from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material';
import { SectionPaper, SectionTitle } from './styledComponents';

const AdditionalNotesSection = ({ invoice, onUpdate, canEdit = true }) => {
  const theme = useTheme();

  const inputSx = {
    borderRadius: 3,
    border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
    background: 'white',
    opacity: canEdit ? 1 : 0.6,
    '& fieldset': { border: 'none' },
    '&:hover': canEdit ? { border: `1px solid ${theme.palette.primary.main}` } : {},
    '&.Mui-focused': canEdit ? { border: `1px solid ${theme.palette.primary.main}`, boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.2)}` } : {}
  };

  return (
    <SectionPaper sx={{ width: '100%', mt: 3 }}>
      <SectionTitle variant="h6"><EditIcon />Additional Notes</SectionTitle>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
            label="Notes to Customer"
            multiline rows={4}
            value={invoice.notes || ''}
            onChange={(e) => canEdit && onUpdate({ notes: e.target.value })}
            fullWidth disabled={!canEdit}
            placeholder="Enter any additional notes for the customer..."
            InputProps={{ sx: inputSx }}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            label="Special Instructions"
            multiline rows={3}
            value={invoice.special_instructions || ''}
            onChange={(e) => canEdit && onUpdate({ special_instructions: e.target.value })}
            fullWidth disabled={!canEdit}
            placeholder="Packing, shipping, or handling instructions..."
            InputProps={{ sx: inputSx }}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            label="Internal Notes"
            multiline rows={2}
            value={invoice.internal_notes || ''}
            onChange={(e) => canEdit && onUpdate({ internal_notes: e.target.value })}
            fullWidth disabled={!canEdit}
            placeholder="Internal notes (not visible to customer)..."
            InputProps={{ sx: inputSx }}
          />
        </Grid>
      </Grid>
    </SectionPaper>
  );
};

export default AdditionalNotesSection;
